const getIterableBackendBaseUrl = require("./getIterableBackendBaseUrl");
/**
 * @return {string}
 */
module.exports = function getIterableBackendBaseApiUrl() {
    return `${getIterableBackendBaseUrl()}/wp-json/itblbackend/v1`;
}
